import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { LandingPageMarketingCard } from '@cp-mx/common';
import { fetchLandingPageMarketingCards } from './LandingPageMarketingCardsSlice';
import { LandingPageMarketingCardsContentSelector } from './LandingPageMarketingCardsContentSelector';

export function useLandingPageMarketingCards(): AbstractContentState<LandingPageMarketingCard[]> {
    return useCmsContent(fetchLandingPageMarketingCards, LandingPageMarketingCardsContentSelector);
}
